import { mono, sans } from '../ui/atoms.js';
import { screenText } from '../ui/screenText.js';
import type { Lang } from '../ui/text.js';

/**
 * A plain screen, centred, for when the voyage cannot be shown: no seat code on this phone,
 * or the room will not let it in. Every one says what happened and what to do next.
 */
export function Notice({
  title,
  lines,
  action,
}: {
  title: string;
  lines: readonly string[];
  action?: { label: string; onClick: () => void };
}) {
  return (
    <main
      className="cc-stars cc-shell"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        // Clear of the notch or the Dynamic Island and the home bar.
        padding: 'calc(32px + env(safe-area-inset-top)) 32px calc(32px + env(safe-area-inset-bottom))',
        boxSizing: 'border-box',
        textAlign: 'center',
        background: '#07080c',
        overflowY: 'auto',
        overscrollBehavior: 'contain',
      }}
    >
      <div
        style={{
          width: 110,
          height: 110,
          flex: 'none',
          borderRadius: '50%',
          border: '1px solid rgba(79,216,194,.35)',
          display: 'grid',
          placeItems: 'center',
        }}
      >
        <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'radial-gradient(circle at 35% 30%,#68e0cc,#1a6f61)' }} />
      </div>
      <h1 style={{ margin: 0, fontFamily: sans, fontSize: 26, fontWeight: 700, letterSpacing: 2, color: '#dfe9f2', textWrap: 'balance' }}>
        {title}
      </h1>
      {lines.map((line) => (
        <p key={line} style={{ margin: 0, fontFamily: mono, fontSize: 14, lineHeight: 1.6, color: '#9db3c2', maxWidth: 320 }}>
          {line}
        </p>
      ))}
      {action && (
        <button
          onClick={action.onClick}
          style={{
            marginTop: 8,
            minHeight: 52,
            minWidth: 200,
            borderRadius: 12,
            border: '1px solid rgba(79,216,194,.6)',
            background: 'transparent',
            color: '#4fd8c2',
            fontFamily: sans,
            fontSize: 16,
            fontWeight: 700,
            letterSpacing: 2.5,
          }}
        >
          {action.label}
        </button>
      )}
    </main>
  );
}

/** Reached without a seat code: someone typed the address instead of scanning. */
export function NoPass({ lang }: { lang: Lang }) {
  const s = screenText(lang);
  return <Notice title={s.noTicketTitle} lines={[s.noTicketScan, s.noTicketHelp]} />;
}
